// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"9540226a3c42d782","793":"42ef63b7ec463244","867":"3d048b140e7efaa2","924":"5236023d32bc8ef6"}[chunkId] + ".js";
};